import { render, staticRenderFns } from "./PreviousMedicationsCard.vue?vue&type=template&id=9e765170&scoped=true&"
import script from "./PreviousMedicationsCard.vue?vue&type=script&lang=js&"
export * from "./PreviousMedicationsCard.vue?vue&type=script&lang=js&"
import style0 from "./PreviousMedicationsCard.vue?vue&type=style&index=0&id=9e765170&prod&scoped=true&lang=css&"
import style1 from "./PreviousMedicationsCard.vue?vue&type=style&index=1&id=9e765170&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e765170",
  null
  
)

export default component.exports